export default __webpack_public_path__ + "static/buzie_2-dd2ee3755ad694856237c0a6096c9707.png";